// NATIVE 
import React, { useEffect } from 'react';


// CUSTOM 
import { Avatar, Skeleton } from '@mui/material';
import { useDispatch } from 'react-redux';
import { deepOrange } from '@mui/material/colors';



// INSTALLED 
import { getImageStore } from '../store/files';




export const AvatarCarnet = ({ urlImage, typeImage }: any) => {


     // DISPATCH 
     const dispatch = useDispatch();


    // USE STATES
    const [logoUrl, setLogoUrl] = React.useState<any>(null);


    const cropImageToCircle = (imageSrc: string): Promise<string> => {
      return new Promise((resolve) => {
         const img = new Image();
         img.crossOrigin = "anonymous";
         img.src = imageSrc;
         img.onload = () => {
            const canvas = document.createElement("canvas");
            const size = Math.min(img.width, img.height);
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext("2d");

            if (ctx) {
            ctx.beginPath();
            ctx.arc(size / 2, size / 2, (size / 2) - 1, 0, Math.PI * 2, true); // 🔹 margen para que no se corte
            ctx.closePath();
            ctx.clip();

            // 🔹 Escalar la imagen al cuadrado para evitar cortes
            ctx.drawImage(img, 0, 0, size, size);
            }

            resolve(canvas.toDataURL("image/png"));
         };
      });
      };



    const getLogoImage = async(imageName:string) => { 
    

          const response =  await dispatch( getImageStore(imageName, typeImage) );

           if ( response instanceof Blob) {
              const imageUrl = URL.createObjectURL(response);
              const croppedImageUrl = await cropImageToCircle(imageUrl);
              setLogoUrl(croppedImageUrl);
           }

    }


    useEffect(() => {
        getLogoImage(urlImage);
    }, [urlImage]);
    

  return (
    <>  
       {
          logoUrl 
          ? <Avatar
                sx={{ bgcolor: deepOrange[500], borderRadius: '50%', width: '100%', height: '100%', textAlign: 'center', zIndex: 1, boxShadow: 999 }}
                sizes={'100'}
                alt="Avatar Empleado"  
                src={ logoUrl }
                variant='circular'
            >
                Q
            </Avatar>
          : <Skeleton animation="wave" variant="circular"  width={'100%'} height={'100%'} />
       }
    </>
  )
}
